import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/context/LanguageContext';
import translations from '@/data/translations';
import { LANDING } from '@/constants/testIds';

export default function Marquee() {
  const { lang } = useLanguage();
  const t = translations[lang].marquee;

  return (
    <div
      data-testid={LANDING.marquee}
      className="relative overflow-hidden bg-[#F4F1EA] border-y border-[#E5DFD3] py-4"
    >
      <motion.div
        animate={{ x: ['0%', '-50%'] }}
        transition={{ duration: 30, repeat: Infinity, ease: 'linear' }}
        className="flex whitespace-nowrap"
      >
        {[0, 1].map((i) => (
          <span
            key={i}
            className="text-[#2C4C3B]/30 text-sm sm:text-base font-semibold tracking-[0.15em] uppercase mx-4"
          >
            {t.text} {t.text} {t.text}
          </span>
        ))}
      </motion.div>
    </div>
  );
}
